import React from "react";
import {Panel, FormControl, Col} from "react-bootstrap";
import AscModal from "../Elements/Modal/Modal";
import ASFieldGroup from "../Elements/FieldGroup/FieldGroup";
import InlineForm from "../Elements/FromGroup/InlineForm";
import AscComponent from "../../components/AscComponent";

export default class ExtensionNumberCheckModal extends AscComponent {
    constructor(props) {
        super(props);

        this.state = {
            company_name: "",
            department_name: "",
            floor_name: "",
            extensions: [],
            // 追加確認ポップアップ関連の状態をpropsStateと同期
            confirmMemo: "",
            confirmValue: ""
        };
        
        // 削除アクション用の確認文字列
        this.confirmAction = this.props.langText.Body.ConfirmValueDelete;
    }

    componentDidMount = () => {
        const {
            company_name,
            companySelect,
            company_id,
            department_name,
            departmentSelect,
            department_id,
            floor_name,
            floor_flg,
            floorSelect,
            floor_id
        } = this.props.propsState;

        this.blockUI();
        let company = "",
            department = "",
            floor = "";

        if (!company_name) company = this.dataSetting(companySelect, company_id);
        if (!department_name) department = this.dataSetting(departmentSelect, department_id);
        if (floor_flg && !floor_name) floor = this.dataSetting(floorSelect, floor_id);

        this.setState({
            company_name: company ? company : company_name,
            department_name: department ? department : department_name,
            floor_name: floor ? floor : floor_name
        }, () => {
            this.unblockUI();
        });
    }

    // 状態更新メソッドを追加
    onTextChange_Limit = (e, field, limit) => {
        const value = e.target.value;
        if (value.length <= limit) {
            this.setState({
                [field]: value
            });
            // 親のstateも同期更新
            if (this.props.propSetState) {
                this.props.propSetState({
                    [field]: value
                });
            }
        }
    }

    dataSetting = (select, id) => {
        let name = select.find(row => row.value === id);

        return name ? name.label : null;
    }

    validationHandle = (param) => {
        let nowState = null;
        const { propsState } = this.props;
        let {
            confirmMemo,
            confirmValue
        } = this.state;

        // 追加確認ポップアップが有効でない場合は常にtrue
        if (!propsState.isSetShowAddingConfirmationPopup) {
            return true;
        }

        switch (param) {
            case "confirmMemo":
                // メモは必須入力で、500文字以内
                nowState = confirmMemo && confirmMemo.length > 0 && confirmMemo.length <= 500
                    ? null
                    : "error";
                break;
            case "confirmValue":
                // 確認値は削除アクションと完全一致が必要
                nowState = confirmValue && confirmValue === this.confirmAction
                    ? null
                    : "error";
                break;
            case "multi_delete":
                // 一括削除全体のバリデーション
                if (propsState.isSetShowAddingConfirmationPopup) {
                    nowState = confirmMemo && confirmMemo.length > 0 && confirmMemo.length <= 500
                        && confirmValue && confirmValue === this.confirmAction;
                } else {
                    nowState = true;
                }
                break;
            default:
                nowState = true;
                break;
        }

        return nowState;
    }

    render() {
        const {
            state,
            propSetState,
            langText,
            propsState,
            onClick,
            omniphoneLoginStatusSearch,
            reactContainerPath
        } = this.props;

        return (
            <AscModal
                key="extension-multi-delete-asc-modal"
                state={state}
                propSetState={propSetState}
                langText={langText}
                validationHandle={this.validationHandle}
                customMsg={langText.Body.DeleteTitle}
                customFunc={async () => {
                    // 追加確認ポップアップが有効な場合はバリデーションチェック
                    if (propsState.isSetShowAddingConfirmationPopup) {
                        if (!this.validationHandle("multi_delete")) {
                            return; // バリデーションエラーの場合は処理を中止
                        }
                    } else {
                        // 追加確認ポップアップが無効な場合は従来の確認ダイアログ
                        if (!window.confirm(langText.Message.User_Delete_Check)) {
                            return;
                        }
                    }

                    try {
                        this.blockUI();
                        let extension_numbers = propsState.extension_ids.map(row => {
                            let extension = propsState.extensionIdSelect.find(info => (info.value === Number(row) & info.type === "android"));
                            return extension ? extension.extension_number : null;
                        }).filter(extension_number => extension_number !== null);

                        let login_data = extension_numbers.length > 0 ? await omniphoneLoginStatusSearch(extension_numbers) : null;
                        this.blockUI();
                        
                        // APIリクエストパラメータ
                        const requestParams = {
                            company_id: propsState.company_id,
                            extension_ids: propsState.extension_ids,
                            department_id: propsState.floor_flg ? propsState.floor_id : propsState.department_id,
                            omniphone_login_data: login_data,
                            send_mail_extension_numbers: propsState.extension_ids.map((id, key) => {
                                return propsState.extensionIdSelect.find(row => row.value === Number(id));
                            })
                        };
                        
                        // 追加確認ポップアップが有効な場合はメモを追加
                        if (propsState.isSetShowAddingConfirmationPopup) {
                            requestParams.confirmMemo = this.state.confirmMemo;
                        }
                        
                        const result = await this.ascAxios("post", `${reactContainerPath}/multiDelete`, requestParams);
                        
                        if (result) {
                            alert(this.sprintf(
                                langText.Message.MultiDeleteSuccess,
                                propsState.extension_ids.length
                            ));
                        }
                    } catch (err) {
                        console.error(err);
                        alert(this.getErrorString(err.response.data));
                    }
                    onClick();
                }}>
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>
                            {langText.Body.CheckDelete}
                        </Panel.Title>
                    </Panel.Heading>

                    <Panel.Body>
                        <div>
                            <p className="preview_add">
                                {langText.Message.Preview_delete}
                            </p>
                            <p>
                                {langText.Message.Preview_delete_message1}
                            </p>
                            <p className="preview_message">
                                {langText.Message.Preview_delete_message2}
                            </p>
                            <hr color="#999"/>
                        </div>

                        <Col sm={12}>
                            <ASFieldGroup
                                key="company_name"
                                label={langText.Body.CompanyName}>
                                <FormControl.Static>{this.state.company_name}</FormControl.Static>
                            </ASFieldGroup>
                            <ASFieldGroup
                                key="department_name"
                                label={langText.Body.DepartmentName}>
                                <FormControl.Static>{this.state.department_name}</FormControl.Static>
                            </ASFieldGroup>
                            {
                                propsState.floor_flg &&
                                    <ASFieldGroup
                                        key="floor_name"
                                        label={langText.Body.FloorName}>
                                        <FormControl.Static>{this.state.floor_name}</FormControl.Static>
                                    </ASFieldGroup>
                            }
                            <ASFieldGroup
                                key="extensions_data"
                                label={this.props.langText.Body.ExtensionNumber}>
                                <Col>{
                                    propsState.extension_ids.map((id, key) => {
                                        let extension_info = propsState.extensionIdSelect.find(row => row.value === Number(id));
                                        return <Col key={key} className="multi_delete_extension">{extension_info ? extension_info.label : ""}</Col>;
                                })}
                                </Col>
                            </ASFieldGroup>
                        </Col>
                    </Panel.Body>
                </Panel>
                {
                    // 追加確認ポップアップ設定がONである場合、追加確認欄を表示
                    propsState.isSetShowAddingConfirmationPopup &&
                    <Panel bsStyle="info">
                        <Panel.Heading>
                            <Panel.Title>
                                {langText.Body.ConfirmValueFieldPersonal}
                            </Panel.Title>
                        </Panel.Heading>
                        <Panel.Body>
                            <p>{this.sprintf(langText.Body.ConfirmInputDescription, this.confirmAction, this.confirmAction)}</p>
                            <br></br>
                            <InlineForm
                                key="confirm-memo"
                                controlId="confirm-memo"
                                label={langText.Body.ConfirmMemo}
                                value={this.state.confirmMemo}
                                onChange={e => this.onTextChange_Limit(e, "confirmMemo", this.props.charaLimit.Confirm_Memo)}
                                validationState={this.validationHandle("confirmMemo")}
                            />
                            <InlineForm
                                label={langText.Body.ConfirmValueField}
                                key="confirm-value"
                                controlId="confirm-value"
                                type="text"
                                value={this.state.confirmValue}
                                onChange={e => this.    onTextChange_Limit(e, "confirmValue", this.props.charaLimit.Confirm_Value)}
                                validationState={this.validationHandle("confirmValue")}
                            />
                        </Panel.Body>
                    </Panel>
                }
            </AscModal>
        );
    }
}
